import { render, staticRenderFns } from "./fundAllocationRecord.vue?vue&type=template&id=f39a9060&scoped=true"
import script from "./fundAllocationRecord.vue?vue&type=script&lang=js"
export * from "./fundAllocationRecord.vue?vue&type=script&lang=js"
import style0 from "./fundAllocationRecord.vue?vue&type=style&index=0&id=f39a9060&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f39a9060",
  null
  
)

export default component.exports